var site = site || {};
site.inits = [];

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.scrollAnchor = {
	init:function () {
		const boxes = document.querySelectorAll('.hero_item');
		boxes.forEach(function (el, index) {
			el.id = 'box-' + index
			if (boxes.length !== (index + 1)) {
				const scrollBtn = document.createElement('a');
				scrollBtn.href = ("#")
				scrollBtn.className = 'scroll-link'
				scrollBtn.setAttribute('data-target', 'box-' + (index + 1))
				el.append(scrollBtn);
			}
		});

		$(document).ready(function () {
			$(window).on('scroll', function() {
				$('.hero_item').each(function() {
					updateScrollLinkVisibility();
				});
			});

			function updateScrollLinkVisibility() {
				$('.hero_item').each(function() {
					const box = $(this);
					const scrollLink = box.find('.scroll-link');
					const boxTop = box.offset().top;
					const viewportTop = $(window).scrollTop();

					if (viewportTop >= boxTop && viewportTop < boxTop + box.height()) {
						scrollLink.show();
					} else {
						scrollLink.hide();
					}
				});
			}

			$('.scroll-link').on('click', function (event) {
				event.preventDefault();

				const targetId = $(this).data('target');
				const targetElement = $('#' + targetId);

				if (targetElement.length) {
					$('html, body').animate({
						scrollTop: targetElement.offset().top
					}, 1000);
				}
			});
		});
	},
}

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');

	if ($body.hasClass('section-page')) {
		site.scrollAnchor.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

});
